import React from "react";
//outsource
import { Row, Col, Space, Button } from "antd";
//components
import TimeFrom from "./component/time_from";
import TimeTo from "./component/time_to";
import SearchByName from "./component/search_by_name";
import { useNavigate } from "react-router-dom";

const IncomeByStaffTopbar = (props) => {
  // -------------------------- VAR --------------------------
  const { search, setSearch } = props;
  const { from, setFrom } = props;
  const { to, setTo } = props;
  const { options } = props;
  const navigate = useNavigate();
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Row>
        <Col style={{ margin: "10px 0px" }} xl={24} lg={24} md={24} xs={24}>
          {renderFilter()}
        </Col>
      </Row>
    );
  };

  const renderFilter = () => {
    return (
      <Row gutter={[10, 10]}>
        <Col xl={4} lg={4} md={12} xs={12}>
          <TimeFrom from={from} setFrom={setFrom} to={to} />
        </Col>
        <Col xl={4} lg={4} md={12} xs={12}>
          <TimeTo from={from} to={to} setTo={setTo} />
        </Col>
        <Col xl={8} lg={8} md={24} xs={24}>
          <SearchByName
            search={search}
            setSearch={setSearch}
            options={options}
          />
        </Col>
        <Col align="right" xl={8} lg={8} md={24} xs={24}>
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/report`)}
          >
            Back
          </Button>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderBody()}
      </Col>
    </Row>
  );
};

export default IncomeByStaffTopbar;
